import * as React from 'react';
import * as mapActions from '../actions/map';
import { connect } from 'react-redux';

import MapSelector from '../components/MapSelector';

class MapSelectorContainer extends React.Component {  
    render () {
        return (
            <MapSelector 
                {...this.props}/>
        );
    };
}

function mapStateToProps(state) {
    return {
        availableMaps: state.map.availableMaps,
        selectedMap: state.map.selectedMap,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setSelectedMap: (renderer) => dispatch(mapActions.setSelectedMap(renderer)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapSelectorContainer);


// WEBPACK FOOTER //
// ./src/containers/MapSelector.js